import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Cookie-based auth (httpOnly session_token cookie set by backend).
// withCredentials ensures the cookie is sent on every request.
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export default api;
